import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const LearningSessionRecord = ({selectedFormId,takingScreenShot,data,selectedClientDetails }) => {
  const { t } = useTranslation();

  const initialFormData = {
    clientName: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
    sessionNumber: "",
    date: "",
    practitionerName: "",
    email: "",
    strategies: {},
    textareaOne: "",
    textareaTwo: "",
    textareaThree: "",
  };

  const [formData, setFormData] = React.useState(initialFormData);
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleStrategyChange = (id, type, value) => {
    setFormData((prev) => ({
      ...prev,
      strategies: {
        ...prev.strategies,
        [id]: {
          ...(prev.strategies[id] || {}),
          [type]: value,
        },
      },
    }));
  };

  const [successModal, setsuccessModal] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();

    const userId = localStorage.getItem("user_id");
    const selectedClient = localStorage.getItem("selectedClient");
    const accessToken = localStorage.getItem("accessToken");

    const client_id = selectedClient === "null" ? userId : selectedClient;

    // Start loader
    setLoading(true);

    // Prepare payload (no need to stringify form_data here)
    const payload = {
      client_id: client_id,
      form_id: selectedFormId, // Ensure this variable is defined
      form_data: JSON.stringify(formData),
      session_id:  localStorage.getItem("selectedSession") || null,
    };

    console.log("📤 Sending form payload test:", payload);

    fetch(API_URL + "/forms/trainer/form-submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((resp) => {
        console.log("✅ Response:", resp);
        if (resp.status) {
          successToggleModal();
          setFormData(initialFormData);
        } else {
          console.error("❌ Upload failed:", resp.message);
          console.log("Upload failed: " + resp.message);
        }
      })
      .catch((err) => {
        console.error("⚠️ Error submitting form:", err);
        console.log("Something went wrong while submitting the form.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Each strategy ID + Label
  const strategiesList = [
    { id: "autonomic", label: "Autonomic learning (HRV feedback)" },
    { id: "awareness", label: "Awareness training (e.g., exhale)" },
    { id: "breaking", label: "Breaking response chains" },
    { id: "capnography", label: "Capnography feedback training" },
    { id: "counterconditioning", label: "Counterconditioning" },
    { id: "creating", label: "Creating/finding new reinforcements" },
    { id: "desensitization1", label: "Desensitization to breathing mechanics" },
    {
      id: "desensitization2",
      label: "Desensitization to effects of hypocapnia",
    },
    { id: "diary", label: "Diary record keeping" },
    { id: "envivo", label: "En vivo learning strategies" },
    { id: "testing", label: "En vivo testing" },
    { id: "exploring1", label: "Exploring altered states" },
    { id: "exploring2", label: "Exploring new behaviors" },
    {
      id: "extinction1",
      label: "Extinction of classically conditioned responses",
    },
    { id: "extinction2", label: "Extinction of reinforced behaviors" },
    { id: "finding", label: "Finding new reinforcements" },
    { id: "generalization", label: "Generalization training (real life)" },
    { id: "guided", label: "Guided overbreathing" },
    { id: "homework", label: "Homework Review" },
    { id: "identifying1", label: "Identifying existing behaviors" },
    { id: "identifying2", label: "Identifying existing reinforcements" },
    { id: "identifying3", label: "Identifying triggers" },
    { id: "learning", label: "Learning new breathing behaviors (shaping)" },
    { id: "linking", label: "Linking breathing with symptoms" },
    { id: "negative", label: "Negative practice" },
    {
      id: "perceptual",
      label: "Perceptual learning (e.g., reflex identification)",
    },
    { id: "preference", label: "Preference development" },
    { id: "recorded", label: "Recorded data review" },
    { id: "reinforcing", label: "Reinforcing alternative behaviors" },
    { id: "secondary", label: "Secondary gain analysis (e.g., headache)" },
    { id: "selfeducation", label: "Self-education and beliefs" },
    { id: "selfobservation", label: "Self-observation lessons" },
    { id: "selfregulating", label: "Self-regulating interventions" },
    { id: "somatic", label: "Somatic learning (EMG feedback)" },
    { id: "symptoms", label: "Symptoms as triggers for good habits" },
    { id: "symptom", label: "Symptom interpretations" },
    { id: "thinking", label: "Thinking and imagining" },
    { id: "trigger", label: "Trigger challenge training" },
  ];

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        fontFamily: "Arial, sans-serif",
        maxWidth: "1200px",
        margin: "0 auto",
      padding: !data?"20px":"10px",
      border: !data && "1px solid #ccc",
        marginTop: "20px",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          color: "#0066cc",
          fontSize: "24px",
          marginBottom: "20px",
        }}
      >
        {t("LEARNING SESSION RECORD")}
      </h1>

      {/* Client Info Section */}
      <div
        style={{
          marginBottom: "15px",
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            flexWrap: "wrap",
            gap: "8px",
            flex: "1 1 300px",
            minWidth: "240px",
          }}
        >
          <span>Client Name:</span>
          <input
            value={formData.clientName}
            disabled={Boolean(selectedClientDetails)}
            onChange={(e) => handleInputChange("clientName", e.target.value)}
            maxLength={50}
            style={{
              flex: "1 1 200px",
              minWidth: "150px",
              backgroundColor: "#f1f4ff",
              border: "none",
              borderBottom: "2px solid #444",
              outline: "none",
              height: "30px",
              padding: "3px 6px",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            flexWrap: "wrap",
            gap: "8px",
            flex: "1 1 300px",
            minWidth: "240px",
          }}
        >
          <span>Session #</span>
          <input
            value={formData.sessionNumber}
            onChange={(e) => handleInputChange("sessionNumber", e.target.value)}
            style={{
              width: "80px",
              backgroundColor: "#f1f4ff",
              border: "none",
              borderBottom: "2px solid #444",
              outline: "none",
              height: "30px",
            }}
          />
          <span>Date:</span>
          <input
            type="text"
            value={formData.date}
            onChange={(e) => handleInputChange("date", e.target.value)}
            style={{
              flex: "1 1 120px",
              minWidth: "100px",
              backgroundColor: "#f1f4ff",
              border: "none",
              borderBottom: "2px solid #444",
              outline: "none",
              height: "30px",
              padding: "3px 6px",
            }}
          />
        </div>
      </div>

      {/* Practitioner Section */}
      <div
        style={{
          marginBottom: "15px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-end",
          gap: "16px",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            flexWrap: "wrap",
            gap: "8px",
            flex: "1 1 300px",
            minWidth: "240px",
          }}
        >
          <span>Practitioner Name:</span>
          <input
            value={formData.practitionerName}
            onChange={(e) =>
              handleInputChange("practitionerName", e.target.value)
            }
            maxLength={100}
            style={{
              flex: "1 1 200px",
              minWidth: "150px",
              backgroundColor: "#f1f4ff",
              border: "none",
              borderBottom: "2px solid #444",
              outline: "none",
              height: "30px",
              padding: "3px 6px",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            flexWrap: "wrap",
            gap: "8px",
            flex: "1 1 300px",
            minWidth: "240px",
          }}
        >
          <span>Email:</span>
          <input
            value={formData.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            maxLength={100}
            style={{
              flex: "1 1 200px",
              minWidth: "150px",
              backgroundColor: "#f1f4ff",
              border: "none",
              borderBottom: "2px solid #444",
              outline: "none",
              height: "30px",
              padding: "3px 6px",
            }}
          />
        </div>
      </div>

      {/* Description */}
      <div style={{ marginBottom: "15px" }}>
        <div
          style={{ color: "#0066cc", fontWeight: "bold", marginBottom: "5px" }}
        >
          Session description and outcomes:
        </div>
        {!takingScreenShot ? (
          <textarea
            value={formData.textareaOne}
            onChange={(e) => handleInputChange("textareaOne", e.target.value)}
            style={{
              border: "1px solid black",
              height: "90px",
              width: "100%",
              backgroundColor: "#f1f4ff",
              outline: "none",
            }}
          />
        ) : (
          <div>{formData.textareaOne}</div>
        )}
      </div>

      {/* Strategies Section */}
      <div style={{ marginBottom: "15px" }}>
        <div
          style={{ color: "#0066cc", fontWeight: "bold", marginBottom: "5px" }}
        >
          Session learning strategies:
        </div>

        {strategiesList.map(({ id, label }) => (
          <div
            key={id}
            style={{
              marginBottom: "8px",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <input
              type="checkbox"
              id={id}
              checked={formData.strategies[id]?.checked || false}
              onChange={(e) =>
                handleStrategyChange(id, "checked", e.target.checked)
              }
              style={{ flexShrink: 0 }}
            />

            <label
              htmlFor={id}
              style={{
                flex: "1 1 180px",
                fontSize: "14px",
                lineHeight: "20px",
                minWidth: "120px",
              }}
            >
              {label}
            </label>

            <input
              type="text"
              value={formData.strategies[id]?.text || ""}
              onChange={(e) => handleStrategyChange(id, "text", e.target.value)}
              maxLength={100}
              style={{
                flex: "1 1 500px",
                minWidth: "180px",
                border: "none",
                borderBottom: "1px solid #444",
                backgroundColor: "#f1f4ff",
                outline: "none",
                height: "30px",
                padding: "4px 6px",
              }}
            />
          </div>
        ))}
      </div>

      {/* Next Objectives */}
      <div style={{ marginBottom: "15px" }}>
        <div
          style={{ color: "#0066cc", fontWeight: "bold", marginBottom: "5px" }}
        >
          Learning objectives for next session:
        </div>
        {!takingScreenShot ? (
          <textarea
            value={formData.textareaTwo}
            onChange={(e) => handleInputChange("textareaTwo", e.target.value)}
            style={{
              border: "1px solid black",
              height: "80px",
              width: "100%",
              backgroundColor: "#f1f4ff",
              outline: "none",
            }}
          />
        ) : (
          <div>{formData.textareaTwo}</div>
        )}
      </div>

      {/* Homework */}
      <div style={{ marginBottom: "15px" }}>
        <div
          style={{ color: "#0066cc", fontWeight: "bold", marginBottom: "5px" }}
        >
          Homework assignment(s) for between now and the next session:
        </div>
        {!takingScreenShot ? (
          <textarea
            value={formData.textareaThree}
            onChange={(e) => handleInputChange("textareaThree", e.target.value)}
            style={{
              border: "1px solid black",
              height: "80px",
              width: "100%",
              backgroundColor: "#f1f4ff",
              outline: "none",
            }}
          />
        ) : (
          <div>{formData.textareaThree}</div>
        )}
      </div>
      {!data && (
        <div className="client-submit-btn">
          <button type="button" onClick={handleSubmit}>
            {loading ? t("Submitting...") : t("Submit")}
          </button>
        </div>
      )}
      <Modal
        isOpen={successModal}
        toggle={successToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={successToggleModal}>
          <span className="ml-1 roititle font-weight-bold">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <p>Trainer form has been submitted successfully.</p>
          </div>
        </ModalBody>
      </Modal>
    </form>
  );
};

export default LearningSessionRecord;
